export const ACTION_TYPES = {
  ACTIVATE: 'activate',
  SET_FOCUS: 'set_focus',
  SET_PARAM: 'set_param',
  SET_VALUE_CUSTOM: 'set_value_custom',
  SET_VALUE: 'set_value',
  SET_VALUE_FROM: 'set_value_from',
  SET_OPTIONS_FROM: 'set_options_from',
  RESET_VALUE: 'resetValue',
  CLEAR_ITEMS: 'clearItems',
  SET_PARAM_FROM: 'set_param_from',
  INCREMENT_ONE: 'increment_1',
  DECREMENT_ONE: 'decrememt_1',
  MODAL_OPEN: 'modal-open',
  MODAL_CLOSE: 'modal-close',
  SET_BG: 'set_bg_color',
  SET_BORDER: 'set_border_color',
  SET_COLOR: 'set_color',
  SET_BG_PASCAL_CASE: 'SetBGColor',
  SET_BORDER_PASCAL_CASE: 'SetBorderColor',
  SET_COLOR_PASCAL_CASE: 'SetColor',

  // TODO: https://titan-scrum.atlassian.net/browse/FT-46 - add more actions
}
